import React, { Component, createRef } from "react";
import { AnchorLink } from "gatsby-plugin-anchor-links";
// enable for modal popup
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faClose } from "@fortawesome/free-solid-svg-icons";

import deviceDetection from "./deviceDetection";
import { _osTrackingEvent } from "./templates/_osTrackingEvent";

import showInterest from "../images/font-icon/interest-trans.png";
import call from "../images/font-icon/call2-trans.png";

import "../css/footer.less";
import "../css/globalRules.less";
import "../css/globalRules.less";

export class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowCookieNote: true,
      isRequestSlide: false,
    };
    this.bookingFormModalRef = createRef();
    this.timeoutIntervalRef = createRef();
    this.modalComponentRef = createRef();
  }

  closeModal = () => {
    if (this.modalComponentRef.current) {
      this.modalComponentRef.current.hide();
      if (window && window.gtag) {
        window.gtag("event", "form_popup_closed", {
          event_category: "form",
          event_label: "Form popup closed",
          car: this.props.carDisplayName,
        });
      }
    }
  };

  dismissCookieNote = () => {
    this.setState({
      isShowCookieNote: false,
    });
  };

  dismissRequestSlide = () => {
    this.setState({
      isRequestSlide: false,
    });
  };

  getFooterDOM(containerClassName) {
    if (!this.state.isShowCookieNote) {
      return null;
    }

    return (
      <div
        className={`py-2 w-100 text-center d-none ${containerClassName} cookieLine`}
      >
        <span className="cookieText">
          We use cookies to ensure that we give you the best experience on the
          website
        </span>
        <span
          className="fa fa-close pull-right"
          onClick={this.dismissCookieNote}
        />
      </div>
    );
  }

  componentDidMount() {
    const myModal = this.bookingFormModalRef.current;
    if (myModal) {
      // Need to Show modal popup then enable this code
      // const modal = new window.bootstrap.Modal(myModal);
      // this.modalComponentRef.current = modal;
      // this.timeoutIntervalRef.current = setTimeout(() => {
      //   modal.show();
      // }, 2000);
    } else {
      this.timeoutIntervalRef.current = setTimeout(() => {
        this.setState({
          isRequestSlide: true,
        });
      }, 2000);
    }
  }

  componentWillUnmount() {
    if (this.timeoutIntervalRef.current) {
      window.clearInterval(this.timeoutIntervalRef.current);
    }
  }

  render() {
    const { isNormalVisit } = this.props;
    const perfMaxClass = isNormalVisit ? "justify-content-md-between" : "justify-content-md-center";
    const contactHref = `tel:${this.props.contact}`;
    const cursorClassName = "cursor-default";
    return (
      <>
        <div className="footer-block-sec">
          <div className="container-fluid footer-bottom py-2 px-0">
            <div className="container d-flex justify-content-center footer-inner">
              <div className={`d-flex col-md-9 mx-auto ${perfMaxClass} justify-content-md-center justify-content-around align-items-center`}>
                <AnchorLink to={`${this.props.carName}/#bookDrive`}>
                  <img src={showInterest} alt="show interest" />
                  Show Interest
                </AnchorLink>
                {
                  isNormalVisit ? (
                    <>
                      <span className="text-white">| </span>
                      <a href={contactHref}
                        className={`footer-contact ${cursorClassName}`}
                        id="footer_call"
                      >
                        <img src={call} alt="call" />
                        Call
                      </a>
                    </>
                  ) : null
                }
              </div>
            </div>
          </div>
        </div>
        {/* enable for modal popup */}
        {/* <div
          ref={this.bookingFormModalRef}
          className="modal fade requestmodal"
          tabIndex="-1"
          aria-labelledby="bookingFormModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
              <div className="modal-body">
                <div className="closemodal" onClick={this.closeModal}>
                  <a className="submitCross" href="javascript:void(0);">
                    <FontAwesomeIcon icon={faClose}></FontAwesomeIcon>
                  </a>
                </div>
                {this.props.bookingFormDom({closeModal: this.closeModal})}
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default deviceDetection(Footer, "(max-width: 1024px)");
